import { useQuery } from "@tanstack/react-query"
import type { ModuleResponse } from "@/shared/api/types/ModuleResponse"
import { useCmApi } from "@/shared/hooks/useCmApi"

const QUERY_KEY = "customerModules"

export const useGetModules = (customerId?: string, enabled = true) => {
  const cmApi = useCmApi()
  const { data, refetch, isLoading, isError, error } = useQuery<ModuleResponse | null>({
    queryKey: [QUERY_KEY, customerId],
    queryFn: () => (customerId ? cmApi.getModules(customerId) : null),
    placeholderData: (prev?: ModuleResponse | null) => prev,
    enabled: enabled && !!customerId
  })

  return {
    data,
    refetch,
    isLoading,
    isError,
    error
  }
}
